import z from 'zod';

export enum NotificationMethodType {
  PHONE = 'phone',
  EMAIL = 'email',
  PUSH = 'push',
}

export interface NotificationMethodDto {
  id: string;
  user_id: string;
  type: NotificationMethodType;
  data: string;
  active: boolean;
  device_id?: string;
  device_name?: string;
  created_at: string;
  updated_at: string;
}

export interface NotificationMethod {
  id: string;
  userId: string;
  type: NotificationMethodType;
  data: string;
  active: boolean;
  deviceId?: string;
  deviceName?: string;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationMethodsFilters {
  /** Per docs the API accepts a CSV list — pass an array to filter by multiple types. */
  type?: NotificationMethodType | NotificationMethodType[];
  active?: boolean;
}

export const createNotificationMethodSchema = z.object({
  type: z.nativeEnum(NotificationMethodType),
  data: z.string().min(1, 'Required field').max(255),
  deviceId: z.string().optional(),
  deviceName: z.string().optional(),
});

export type CreateNotificationMethodFormValues = z.infer<typeof createNotificationMethodSchema>;

export const updateNotificationMethodSchema = z.object({
  id: z.string().uuid(),
  type: z.nativeEnum(NotificationMethodType).optional(),
  data: z.string().max(255).optional(),
  active: z.boolean().optional(),
});

export type UpdateNotificationMethodFormValues = z.infer<typeof updateNotificationMethodSchema>;
